import React from "react";

const statusColor = {
  PENDING: "orange",
  APPROVED: "green",
  DEACTIVATE: "red",
};

export function tabMenuItem(label, count, status) {
  const color = statusColor[status];
  return {
    content: (
      <span className="tab_menu_label">
        {label}
        {count > 0 && (
          <span className={`tab_count_badge tab_count_badge_${color}`}>
            {count}
          </span>
        )}
      </span>
    ),
    disabled: count === 0
  };
}
